import { render, staticRenderFns } from "./ArticleCateTree.vue?vue&type=template&id=6c12ed6a&scoped=true"
import script from "./ArticleCateTree.vue?vue&type=script&lang=js"
export * from "./ArticleCateTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c12ed6a",
  null
  
)

export default component.exports